// Format is /editor/privateBranch1 /editor/privateBranch1/{asset}/{assetName}
// Returns the private branch name if matches
export const getBranchNameFromUrl = (): string | undefined => {
  const url = window.location.pathname;

  if (!url.startsWith('/editor/')) { return; }
  const parts = url.split('/');
  if (parts[2] === 'branch') {
    return decodeURIComponent(parts[3]);
  }
  return decodeURIComponent(parts[2]);
};
